import { render, staticRenderFns } from "./KabKotPopup.vue?vue&type=template&id=5fef7e46&scoped=true"
import script from "./KabKotPopup.vue?vue&type=script&lang=js"
export * from "./KabKotPopup.vue?vue&type=script&lang=js"
import style0 from "./KabKotPopup.vue?vue&type=style&index=0&id=5fef7e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef7e46",
  null
  
)

export default component.exports